import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

const renderQuotaCleanerPage = () => openPopupHelper({ popupName: popupNames.QUOTA_CLEANER_PAGE });

class QuotaCleanerPageManager {
    private _dialog;

    render() {
        if (!this._dialog) {
            this._dialog = renderQuotaCleanerPage();
        }
    }

    close() {
        this._dialog?.closeDialog();
        this._dialog = null;
    }
}

export const quotaCleanerPageManager = new QuotaCleanerPageManager();
